import React from 'react';
import "./SvgContainer.css"

import Svg1 from "../Assets/svg/svg1.png";

function SvgContainer() {
  return (
    <div className='svg-container svg-container1 '>
        <img src={Svg1} alt='' />
    </div>
  )
}

export default SvgContainer